import { useEffect, useRef } from 'react';

export function useRfidScan({ inputRef, onScan, autoFocus = true, autoClear = true, idleMs = 200 } = {}) {
  const bufferRef = useRef('');
  const timerRef = useRef(null);

  useEffect(() => {
    if (!autoFocus) return;
    const el = inputRef?.current;
    if (el && typeof el.focus === 'function') {
      try { el.focus(); } catch { /* ignore */ }
    }
  }, [autoFocus, inputRef]);

  useEffect(() => {
    const el = inputRef?.current;
    if (!el) return undefined;

    const flush = () => {
      const uid = bufferRef.current.trim();
      bufferRef.current = '';
      if (uid && typeof onScan === 'function') onScan(uid);
      if (autoClear) {
        try { el.value = ''; } catch { /* ignore */ }
      }
    };

    const handleKey = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (timerRef.current) clearTimeout(timerRef.current);
        flush();
        return;
      }
      if (e.key && e.key.length === 1) {
        bufferRef.current += e.key;
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => flush(), idleMs);
      }
    };

    const handleChange = () => {
      bufferRef.current = el.value || '';
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => flush(), idleMs);
    };

    el.addEventListener('keydown', handleKey);
    el.addEventListener('input', handleChange);
    return () => {
      el.removeEventListener('keydown', handleKey);
      el.removeEventListener('input', handleChange);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [inputRef, onScan, autoClear, idleMs]);
}
